import React, { useState } from 'react';
import { Modal, Form, Input, Button, message, Alert } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { changePassword } from '../services/api';

interface FirstLoginPasswordModalProps {
  isOpen: boolean;
  onSuccess: () => void;
}

const FirstLoginPasswordModal: React.FC<FirstLoginPasswordModalProps> = ({ isOpen, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async (values: { newPassword: string; confirmPassword: string }) => {
    if (values.newPassword !== values.confirmPassword) {
      message.error('两次输入的密码不一致');
      return;
    }

    if (values.newPassword.length < 6) {
      message.error('密码长度至少6位');
      return;
    }

    try {
      setLoading(true);
      const response = await changePassword('111111', values.newPassword); // 默认密码是111111
      if (response.success) {
        message.success('密码修改成功！');
        onSuccess();
      } else {
        message.error(response.error || '密码修改失败');
      }
    } catch (error) {
      message.error('密码修改失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="首次登录 - 修改密码"
      open={isOpen}
      closable={false}
      maskClosable={false}
      footer={null}
      width={400}
      centered
    >
      <Alert
        message="安全提示"
        description="为了您的账户安全，请修改默认密码。默认密码为 111111"
        type="warning"
        showIcon
        style={{ marginBottom: 20 }}
      />
      
      <Form
        form={form}
        name="firstLoginPassword"
        onFinish={handleSubmit}
        layout="vertical"
        size="large"
      >
        <Form.Item
          name="newPassword"
          label="新密码"
          rules={[
            { required: true, message: '请输入新密码!' },
            { min: 6, message: '密码长度至少6位!' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="请输入新密码"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="确认新密码"
          rules={[
            { required: true, message: '请确认新密码!' },
            { min: 6, message: '密码长度至少6位!' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="请再次输入新密码"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            className="login-button"
          >
            {loading ? '修改中...' : '修改密码'}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FirstLoginPasswordModal;
